import React from 'react';

import { InfoContainer, IconContainer, Content, Title, Info as InfoValue } from './styles';

interface Props {
  icon?: string;
  title: string;
  info?: string;
  children?: JSX.Element;
}

const Info = ({ icon, title, info, children }: Props) => (
  <InfoContainer>
    <IconContainer>{icon && <img src={icon} alt="" />}</IconContainer>
    <Content>
      <Title>{title}</Title>
      {info ? <InfoValue>{info}</InfoValue> : <InfoValue>{children}</InfoValue>}
    </Content>
  </InfoContainer>
);

export default Info;
